import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {FormUtentiAutocompleteComponent} from '../../../shared/components/form-utenti-autocomplete/form-utenti-autocomplete.component';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {SelectItem} from 'primeng/api';
import {getOwnerTypeOptions, OwnerType, UserInfoModel} from '../../../shared/models';
import {
	FooterButtonsComponent,
	FormInputNumberComponent,
	FormInputTextComponent,
	FormSelectComponent,
	FormUtilsService,
	UtilsService
} from '@shared-lib';
import {DialogsUtilsService} from '../../../core/service/utils/dialogs-utils.service';
import {Subscription} from 'rxjs';
import {WalletService} from '../../../core/service/kleros/wallet/wallet.service';

@Component({
	selector: 'crea-wallet-dialog',
	imports: [
		FormUtentiAutocompleteComponent,
		TranslatePipe,
		FormSelectComponent,
		FormInputTextComponent,
		FormInputNumberComponent,
		FooterButtonsComponent
	],
	template: `
    <div class="flex flex-column gap-3">
      <form-select [label]="'tipo'|translate"
                   [options]="ownerTypes"
                   [control]="formGroup.controls['tipo']"
                   [placeholder]="'select_ph'|translate"
                   (onChange)="resetFields()">
      </form-select>
      @let tipoWallet = formGroup.controls['tipo'].value;
      @if (tipoWallet) {
        <div class="fadein flex flex-column gap-3">
          <form-utenti-autocomplete [label]="'email'|translate"
                                    [infoTooltipText]="'utenteIscrittoWarning'|translate"
                                    [control]="formGroup.controls['mail']"
                                    (selectedUserData)="manageSelectedUser($event)">
          </form-utenti-autocomplete>
          @if (OwnerType.COMPANY === tipoWallet && aziendaDescriptionFC.value) {
            <form-input-text class="flip"
                             [label]="'azienda'|translate"
                             [control]="aziendaDescriptionFC"
                             [readOnly]="true">
            </form-input-text>
          }
          <form-input-number [label]="'alertThreshold'|translate" mode="currency" currency="EUR"
                             [control]="formGroup.controls['alertThreshold']">
          </form-input-number>
        </div>
      }
    </div>
    <div class="sticky-modal-footer pt-3">
      <footer-buttons [confirmText]="'salva'|translate"
                      [dismissText]="'annulla'|translate"
                      [confirmDisabled]="formGroup.invalid"
                      (confirmClicked)="creaWallet()"
                      (dismissClicked)="dialogRef.close()">
      </footer-buttons>
    </div>
	`
})
export class CreaWalletDialogComponent implements OnInit, OnDestroy {

	protected dialogRef = inject(DynamicDialogRef);
	private dialogUtils = inject(DialogsUtilsService);
	private fs = inject(FormUtilsService);
	private translate = inject(TranslateService);
	private walletService = inject(WalletService);
	private utils = inject(UtilsService);

	protected readonly OwnerType = OwnerType;

	ownerTypes: SelectItem<OwnerType>[] = [];

	aziendaDescriptionFC: FormControl = new FormControl(); // per visualizzazione in sola lettura descrizione azienda se tipo = "COMPANY"

	formGroup: FormGroup = new FormGroup({
		tipo: new FormControl(null, Validators.required),
		mail: new FormControl(null, Validators.required),
		idAzienda: new FormControl(null),
		initialBalance: new FormControl(0), // default in creazione sempre a 0
		alertThreshold: new FormControl(null, Validators.min(0))
	});

	private subscriptions: Subscription = new Subscription();

	ngOnInit() {
		this.ownerTypes = getOwnerTypeOptions(this.translate);
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	resetFields() {
		this.fs.resetFormFields(['mail', 'idAzienda'], this.formGroup);
	}

	protected manageSelectedUser(userData: UserInfoModel) {
		if (!!userData) {
			if (this.formGroup.controls['tipo'].value === OwnerType.COMPANY && !userData.azienda.id) {
				// se l'utenza selezionata NON ha un'azienda collegata --> errore
				this.dialogUtils.openAdviseDialog(this.translate.instant('errore'), this.translate.instant('errore_utenteNOAzienda'));
				this.formGroup.controls['mail'].reset(); // resetto la selezione email
			} else {
				this.formGroup.controls['idAzienda'].setValue(userData.azienda.id);
				this.aziendaDescriptionFC.setValue(userData.azienda.nome);
			}
		} else {
			this.formGroup.controls['idAzienda'].reset();
			this.aziendaDescriptionFC.reset();
		}
	}

	creaWallet() {
		this.subscriptions.add(this.utils.spinnerRestCall(this.walletService.createWallet(this.formGroup.value), true)
			.subscribe(() => {
				this.utils.fireConfirmationToast(this.translate.instant('walletCreatoInfoMsg'));
				this.dialogRef.close();
				// TODO - se la mail è == a utente corrente --> logout automatico come per licenze (solo gli admin...)
			}));
	}
}
